import axios from 'axios'

import { parseAuthenticationHeader } from 'helpers/Functions'
import { TResourceVariant } from 'types/GlobalResource'

export type TResourceStatusItem = {
  resource_id: string
  latest_visit: string | null
  favorite: boolean
}

export type TResourceStatusResponse = TResourceStatusItem[]

const BASE_URL =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:3990/'
    : process.env.REACT_APP_HOMEPAL_MDM_API_PROD

const URL = `${BASE_URL}v1/resource-statuses`

export async function getAll() {
  return axios.get<{ data: TResourceStatusResponse }>(
    URL,
    parseAuthenticationHeader()
  )
}

export async function putResourceStatus(
  id: string,
  resourceType: TResourceVariant
) {
  return axios.put<{ data: TResourceStatusResponse }>(
    `${URL}/${id}/favorite`,
    { data: { resource_type: resourceType } },
    parseAuthenticationHeader()
  )
}
